import HBSwiper from "@/components/HBSwiper";
import Image from "@/components/Image";
import { TrackerDiv } from "@/components/Tracker";
import { getTopicDetail } from "@/services";
import { button_click } from "@/tracker/collecter/buttonClick";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import { Skeleton } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { When } from "react-if";
import Card from "./card";
import styles from "./index.module.less";
export default function MaterialCollection({ data, className, isSmall }) {
  const router = useRouter();
  const { _cache } = router.query;
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState({
    [`${index}`]: data?.firstPins,
  });

  const getPinList = async (data, index) => {
    let id = data?.id?.trim();
    let topic = await getTopicDetail({
      urlname: id,
      preview_limit: 5,
      preview_cache: !_cache,
      preview_material: 1,
    });

    const materials = topic?.content?.materials;
    if (!materials?.length) {
      return undefined;
    }
    let fulfilledResults = materials?.map((item) => {
      const { preview, material } = item;
      return {
        pins: preview?.pins,
        pin_count: preview?.pin_count,
        filter: {
          value: material?.filter.value,
          title: material?.title,
        },
        ...data,
      };
    });
    setDataSource((dataSource) => {
      return {
        ...dataSource,
        [`${index}`]: fulfilledResults,
      };
    });
  };

  const onChangeTab = (i, e) => {
    setIndex(i);
    button_click(e.target);
    if (!dataSource[i]) {
      getPinList(data?.scene[i], i);
    }
  };
  useEffect(() => {
    if (!dataSource[index]) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [dataSource, index]);

  return (
    <div className={classNames([styles.category, className])}>
      <div className={styles.header}>
        <div className={styles.left}>
          <div className={styles.title}>
            {data?.titleIcon && (
              <Image
                {...gdImgSrcPolicy(data.titleIcon, {
                  displayWidth: 24,
                  displayHeight: 24,
                })}
                alt={"标题icon"}
              />
            )}
            <span> {data?.title}</span>
          </div>
          <div className={styles.description}>{data?.description}</div>
        </div>
        <div className={styles.right}>
          <HBSwiper
            className={styles.tabswiper}
            contentClassName={styles.tabswiperContent}
            iconClassName={styles.icon}
            padding={20}
          >
            <div className={styles.tab}>
              {data?.scene?.map((item, i) => (
                <TrackerDiv
                  className={classNames([
                    styles.item,
                    i === index ? styles.active : null,
                  ])}
                  key={i}
                  data-gd-click="button_click"
                  data-button-name={`内容合集_${data.title}_${item.title}`}
                  data-content-source={`内容合集_${data.title}`}
                  onMouseEnter={(e) => onChangeTab(i, e)}
                >
                  <When condition={item?.labelText}>
                    <span
                      className={styles.label}
                      style={
                        item?.labelColor
                          ? { backgroundColor: item?.labelColor }
                          : null
                      }
                    >
                      {item?.labelText}
                    </span>
                  </When>
                  {item?.title}
                </TrackerDiv>
              ))}
            </div>
          </HBSwiper>
        </div>
      </div>
      {loading ? (
        <div className={styles.loadingContent}>
          {new Array(isSmall ? 4 : 5).fill("").map((item, index) => {
            return (
              <Skeleton.Input
                active
                className={styles.skeletonCard}
                key={index}
              ></Skeleton.Input>
            );
          })}
        </div>
      ) : (
        <HBSwiper className={styles.swiper} iconClassName={styles.icon}>
          <div className={styles.list}>
            {dataSource[index]?.map((item, index) => {
              const {
                pin_count,
                filter,
                pins,
                id,
                isHomeImage,
                homeImage,
                title,
              } = item;
              return (
                !!pins?.length && (
                  <Card
                    isHomeImage={index === 0 && isHomeImage}
                    homeImage={homeImage}
                    pinCount={pin_count}
                    filter={filter}
                    title={title}
                    pins={pins}
                    topicId={id}
                    key={index}
                  ></Card>
                )
              );
            })}
          </div>
        </HBSwiper>
      )}
    </div>
  );
}
